// frontend/modules/drafts/types/index.ts

/**
 * Draft process statuses
 */
export enum DraftProcessStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  FAILED = 'FAILED'
}

/**
 * Draft process entity interface
 */
export interface DraftProcess {
  id: string;
  name: string;
  processType: string;
  userId: string;
  status: DraftProcessStatus;
  processData: string; // JSON string containing process-specific data
  documentIds?: string; // Comma-separated list of document IDs
  createdAt: string;
  updatedAt: string;
  completedAt?: string;
}

/**
 * Request to create a new draft process
 */
export interface DraftProcessCreateRequest {
  name: string;
  processType: string;
  processData: string;
  documentIds?: string;
}

/**
 * Request to update an existing draft process
 */
export interface DraftProcessUpdateRequest {
  name?: string;
  processData?: string;
  documentIds?: string;
}

/**
 * Response from draft process API
 */
export interface DraftProcessResponse {
  status: number;
  message: string;
  data: DraftProcess;
}

/**
 * Response for listing draft processes
 */
export interface DraftProcessListResponse {
  status: number;
  message: string;
  data: DraftProcess[];
}

export * from './handlers';
